import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import {useStyles} from './helper';
import { setPostCreatePaymentSystem } from '../../store/thunk/setPostCreatePaymentSystem';
import { useDispatch } from 'react-redux';

const DialogPayment = ({openModal, setOpenModal}) => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const [value, setValue] = React.useState('');

    return (
        <Dialog onClose={() => setOpenModal(false)} open={openModal}>
            <div className={classes.root}>
                <div className={classes.wrapTitle}>
                    <span className={classes.title}>Добавить платежную систему</span>
                </div>
                <div>
                    <label htmlFor="" className={classes.wrapInput}>
                        <span>Название</span>
                        <input 
                            type="text"
                            className={classes.input}
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                        />
                    </label>
                </div>
                <div 
                    className={classes.wrapBtn}
                    onClick={() => {
                        dispatch(setPostCreatePaymentSystem({
                            label: value,
                        }))
                        setOpenModal(false);
                    }}    
                >
                    <span className={classes.btn}>Создать</span>
                </div>
            </div>
        </Dialog>
    )
}

export default DialogPayment;